import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { IRealEstateReport } from '../interfaces';
import { getRealEstateReports } from '../api';

export function useGetRealEstateReports(realEstateGuid: string) {
  const [{ loading, data, error }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: Map<string, { list: IRealEstateReport[]; totalCount: number }>;
  }>({ loading: false, error: null, data: new Map() });

  const fetchReports = async (config?: AxiosRequestConfig, skip: boolean = true) => {
    const mapKey = JSON.stringify(
      Object.entries(config?.params)
        .map(([, value]) => value)
        .filter(Boolean),
    );
    if (skip && data.has(mapKey)) return;

    setData((prevState) => ({ ...prevState, loading: true }));

    try {
      const response = await getRealEstateReports(realEstateGuid, config);

      setData((prevState) => {
        const newData = new Map(prevState.data);
        newData.set(mapKey, response);
        return { ...prevState, data: newData };
      });
    } catch (error) {
      setData((prevState) => ({ ...prevState, error: (error as AxiosError).response?.data.message }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  return { loading, data, error, fetchReports };
}
